import React from 'react';
import { CaretUp, CaretDown } from '@phosphor-icons/react';

/**
 * Rank movement indicator. Positive = moved up (green), negative = moved down (red).
 * Renders nothing if movement is 0 or null.
 */
export default function RankMovement({ movement, testId }) {
  if (!movement) return null;
  const up = movement > 0;
  const value = Math.abs(movement);

  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-0.5 text-[10px] font-semibold px-1.5 py-0.5 rounded-full ${
        up ? 'bg-[#015e3f]/10 text-[#015e3f]' : 'bg-red-50 text-red-600'
      }`}
      title={up ? `Moved up ${value} places` : `Moved down ${value} places`}
    >
      {up ? <CaretUp size={10} weight="bold" /> : <CaretDown size={10} weight="bold" />}
      {up ? '+' : '-'}{value}
    </span>
  );
}
